import styled, { css } from "styled-components";

const type = {
  heading1: css`
    font-family: "Aeonik", sans-serif;
    font-size: 28px;
    line-height: 28px;
    font-weight: 500;
  `,
  heading2: css`
    font-family: "Aeonik", sans-serif;
    font-size: 20px;
    line-height: 24px;
    font-weight: 500;
  `,
  heading3: css`
    font-family: "Aeonik", sans-serif;
    font-size: 18px;
    line-height: 22px;
    font-weight: 400;
  `,
  heading4: css`
    font-family: "Aeonik", sans-serif;
    font-size: 14px;
    line-height: 22px;
    font-weight: 400;
  `,
  heading5: css`
    font-family: "Aeonik", sans-serif;
    font-size: 13px;
    line-height: 14px;
    font-weight: 400;
  `,
  bodyLarge: css`
    font-family: "Inter", sans-serif;
    font-size: 17px;
    line-height: 18px;
    font-weight: 500;
  `,
  body: css`
    font-family: "Inter", sans-serif;
    font-size: 14px;
    line-height: 18px;
    font-weight: 400;
  `,
  small: css`
    font-family: "Inter", sans-serif;
    font-size: 12px;
    line-height: 16px;
    font-weight: 400;
    letter-spacing: 0.15px;
  `,
  meta: css`
    font-family: "Inter", sans-serif;
    font-size: 10px;
    font-weight: 400;
    line-height: 14px;
  `,
  caption: css`
    font-family: "Unica", sans-serif;
    font-size: 8px;
    font-weight: 400;
    line-height: 10px;
    text-transform: uppercase;
    letter-spacing: 1px;
  `,
  label: css`
    font-family: "Inter", sans-serif;
    font-size: 9px;
    font-weight: 500;
    line-height: 14px;
    letter-spacing: 0.15px;
  `,
};

export default type;

export const StyledBodyLarge = styled.div`
  ${type.bodyLarge}
`;
